enum CustomerAuthRole {
  CUSTOMER = 'CUSTOMER',
  GUEST = 'GUEST',
}

export { CustomerAuthRole };
